import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseURL } from "../../Config";
import { PROFILE_API, EDIT_DOCTOR_PROFILE_PIC, DETAIL_OFFICE_EMPLOYEE_API } from "../../Helper/ApiPath";
import {
    ACCESSLEVEL,
    ADDRESS,
    BIRTH_DATE,
    CHOOSE_DOCTOR_TYPE,
    CITY,
    DASH,
    DOCTOR_CODE,
    DOCTOR_INFORMATION,
    DOCTOR_PROFILE,
    DOCTOR_SPECIALTY,
    EMAIL,
    FIRST_NAME,
    GENDER,
    HOME,
    LAST_NAME,
    LICENSE_NUMBER,
    OFFICE_EMPLOYEE_INFORMATION,
    OFFICE_EMPLOYEE_PROFILE,
    PHONE_NO,
    PTAN_NUMBER,
    STATE,
    UPLOAD,
    VIEW_PROFILE,
} from "../../Helper/Constants";
import { dateFormateMonthDateYear } from "../../Helper/Helper";
import OfficeDetail from "./OfficeDetail";
import { NavLink, useNavigate } from "react-router-dom";
import { UPLOAD_IMAGE } from "../../Helper/Messages";
import Cookies from "universal-cookie";

function DoctorProfilePage() {
    const cookies = new Cookies();

    let doctorId = localStorage.getItem("doctorId");
    let logToken = JSON.parse(localStorage.getItem("logToken")).token;
    let isTrial = cookies.get("isTrial");
    if (isTrial) {
        isTrial = cookies.get("isTrial").isTrial;
    }
    const [profileInfo, setProfileInfo] = useState([]);
    let [image, setImage] = useState({ preview: "", data: "" });
    const navigate = useNavigate();
    const fetchData = async () => {
        await axios
            .get(`${baseURL}/${PROFILE_API}/${doctorId}`, {
                headers: { authorization: logToken },
            })
            .then((res) => {
                setProfileInfo(res.data.data);

                if (res.data.data.profilePic && res.data.data.profilePic != "NULL") {
                    const img = {
                        preview: res.data.data.profilePic,
                        data: "",
                    };
                    setImage(img);
                }
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };

    const handleUpload = async () => {
        let formData = new FormData();
        if (!image.data) {
            toast.error(UPLOAD_IMAGE);
        } else {
            formData.append("profilePic", image.data);
            formData.append("id", doctorId);
            await axios
                .post(`${baseURL}/${EDIT_DOCTOR_PROFILE_PIC}`, formData, {
                    headers: { authorization: logToken, "Content-Type": "multipart/form-data", accept: "application/json" },
                })
                .then((res) => {
                    console.log("image.data", image.data);
                    if (res.status === 200) {
                        toast.success(res.data.message);
                        let element = document.getElementById("button");
                        element.classList.add("d-none");
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status == 500) {
                            localStorage.clear();
                            navigate("/login");
                        } else {
                            toast.error(err.response.data.message);
                        }
                    }
                });
        }
    };

    const handleFileChange = (e) => {
        const img = {
            preview: URL.createObjectURL(e.target.files[0]),
            data: e.target.files[0],
        };

        const fileExtension = img.data.name.split(".").at(-1).toLowerCase();
        const allowedFileTypes = ["jpg", "png", "jpeg"];
        if (!allowedFileTypes.includes(fileExtension)) {
            alert(`File does not support. Files type must be ${allowedFileTypes.join(", ")}`);
        } else {
            let element = document.getElementById("button");
            element.classList.remove("d-none");
            setImage(img);
        }
    };

    const [employeeInfo, setOfficeEmployeeInfo] = useState([]);

    const fetchOfficeEmployeeData = async () => {
        await axios
            .get(`${baseURL}/${DETAIL_OFFICE_EMPLOYEE_API}/${doctorId}`, {
                headers: { authorization: logToken },
            })
            .then((res) => {
                if (res.status === 200) {
                    setOfficeEmployeeInfo(res.data.data);
                }
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };

    useEffect(() => {
        if (isTrial == 2) {
            fetchOfficeEmployeeData();
        } else {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {/* <ToastContainer /> */}
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title">{isTrial == 2 ? OFFICE_EMPLOYEE_PROFILE : DOCTOR_PROFILE}</div>
                            </div>
                            {isTrial == 0 || isTrial == 2 ? (
                                <ol className="breadcrumb page-breadcrumb pull-right">
                                    <li>
                                        <i className="fa fa-home"></i>&nbsp;
                                        <NavLink className="parent-item" to="/dashboard">
                                            {HOME}
                                        </NavLink>
                                        &nbsp;<i className="fa fa-angle-right"></i>
                                    </li>
                                    <li className="active">{VIEW_PROFILE}</li>
                                </ol>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className={`${isTrial == 1 ? "col-8 offset-2" : "col-md-8"} `}>
                            <div className="profile-content">
                                <div className="row">
                                    {isTrial == 2 ? (
                                        <div className="card">
                                            <div className="card-head">
                                                <header>{OFFICE_EMPLOYEE_INFORMATION}</header>
                                            </div>
                                            <div className="white-box p-0 mb-2">
                                                <div className="tab-content">
                                                    <div className="tab-pane active fontawesome-demo" id="tab1">
                                                        <div id="biography">
                                                            <div className="row">
                                                                <ol className="list-group list-group-unbordered ">
                                                                    <h3 className="my-3">
                                                                        <b>
                                                                            {employeeInfo.firstName} {employeeInfo.lastName}
                                                                        </b>
                                                                    </h3>
                                                                    {employeeInfo.email ? (
                                                                        <li className="list-group-item">
                                                                            <b>{EMAIL}</b>
                                                                            <div className="profile-desc-item pull-right">{employeeInfo.email ? employeeInfo.email : DASH}</div>
                                                                        </li>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <li className="list-group-item">
                                                                        <b>{FIRST_NAME}</b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.firstName ? employeeInfo.firstName : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{LAST_NAME}</b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.lastName ? employeeInfo.lastName : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{ADDRESS} </b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.address1 ? employeeInfo.address1 : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{STATE}</b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.stateName ? employeeInfo.stateName : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{CITY}</b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.cityName ? employeeInfo.cityName : DASH}</div>
                                                                    </li>

                                                                    <li className="list-group-item">
                                                                        <b>{ACCESSLEVEL}</b>
                                                                        <div className="profile-desc-item pull-right">{employeeInfo.accessLvl ? employeeInfo.accessLvl : DASH}</div>
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="card">
                                            <div className="card-head">
                                                <header>{DOCTOR_INFORMATION}</header>
                                            </div>
                                            <div className="white-box p-0 mb-2">
                                                <div className="tab-content">
                                                    <div className="tab-pane active fontawesome-demo" id="tab1">
                                                        <div id="biography">
                                                            <div className="row">
                                                                <div className="col-5">
                                                                    <form action="" encType="multipart/form-data">
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            {image.preview ? (
                                                                                <img
                                                                                    src={image.preview}
                                                                                    width="100"
                                                                                    height="100"
                                                                                    className="img-circle user-img-circle my-5 "
                                                                                    alt="User Image"
                                                                                    style={{ height: "190px", width: "190px" }}
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    src="assets/img/logo/login-logo.png"
                                                                                    className="img-circle user-img-circle my-5"
                                                                                    alt="User Image"
                                                                                    style={{ height: "190px" }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </form>
                                                                    <div className="row">
                                                                        <div className="offset-1 col-11 d-flex justify-content-center">
                                                                            <input
                                                                                type="file"
                                                                                name="file"
                                                                                id="uploadFile"
                                                                                onChange={handleFileChange}
                                                                                accept="image/png, image/jpg, image/jpeg"
                                                                            ></input>
                                                                        </div>
                                                                        <div className="offset-5 col-7">
                                                                            <button type="button" className="btn btn-primary mt-2 d-none" id="button" name="profileUpload" onClick={handleUpload}>
                                                                                {UPLOAD}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <ol className="list-group list-group-unbordered col-7">
                                                                    <h3 className="my-3">
                                                                        <b>
                                                                            {profileInfo.firstName} {profileInfo.lastName}
                                                                        </b>
                                                                    </h3>
                                                                    {profileInfo.email ? (
                                                                        <li className="list-group-item">
                                                                            <b>{EMAIL}</b>
                                                                            <div className="profile-desc-item pull-right">{profileInfo.email ? profileInfo.email : DASH}</div>
                                                                        </li>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <li className="list-group-item">
                                                                        <b>{DOCTOR_CODE}</b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.code ? profileInfo.code : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{LICENSE_NUMBER}</b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.licenseNumber ? profileInfo.licenseNumber : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{GENDER} </b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.gender ? profileInfo.gender : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{BIRTH_DATE}</b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.dob ? dateFormateMonthDateYear(profileInfo.dob) : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{DOCTOR_SPECIALTY}</b>
                                                                        <div className="profile-desc-item pull-right">
                                                                            {profileInfo.speciality ? profileInfo.specialtyName : DASH}
                                                                        </div>
                                                                    </li>

                                                                    <li className="list-group-item">
                                                                        <b>{PTAN_NUMBER}</b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.ptanNumber ? profileInfo.ptanNumber : DASH}</div>
                                                                    </li>
                                                                    <li className="list-group-item">
                                                                        <b>{PHONE_NO}</b>
                                                                        <div className="profile-desc-item pull-right">{profileInfo.phoneNo1 ? profileInfo.phoneNo1 : DASH}</div>
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {isTrial == 0 || isTrial == 2 ? <OfficeDetail /> : ""}
                    </div>
                </div>
            </div>
        </>
    );
}

export default DoctorProfilePage;
